module.exports = __webpack_public_path__ + "img/01logo-wss2021.8d44414a.png";